import React from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import ServiceShowcase from "../ServiceShowCase";
import CardsContainer from "../CardsContainer.jsx";
import CoverHero from "../CoverHero";
import Testimonials from "../../Testimonial/Testimonial.jsx";
import ServicesGrid from "../ServiceGrid.jsx";
import banner from "../../Assets/cover.png";

import {
  serviceShowcaseData,
  medicineHeading1,
  medicineParagraph1,
  medicinedelivered,
  cardsh2,
  cardsh4,
  cardspara,
  prescriptiondata,
  rightfitdata,
  pharmacyqueuesdata,
  rightfittitle,
  medicinehomeData,
} from "../MedicineHome/medicinehome.js";
import "./medicinehome.css";
import { useState } from "react";
import LoginModal from "../../Modals/LoginModal.js";
import { useNavigate } from "react-router-dom";

const Medicinehome = () => {
 const navigate = useNavigate();
  return (
    <>
      <Header />
      <CoverHero image={banner} title="Medicine Home Delivery" />
      <div className="servicesShowCase">
        {serviceShowcaseData.map((service, index) => (
          <ServiceShowcase
            key={index}
            className="medicinehome-servicewrapper"
            data={service}
            onServiceClick={() => navigate('/')}
          />
        ))}
      </div>
     
      <div className="texts-medicinehome">
        <h2>{medicineHeading1}</h2>
        <p>{medicineParagraph1}</p>
      </div>

      <div className="medicines-delivered">
        <CardsContainer
          heading={cardsh2}
          subheading={cardsh4}
          paragraph={cardspara}
          services={Object.values(medicinedelivered)}
          className="medicinehome-cardscontainer"
        />
      </div>

      <div className="feeling-unwell">
        <div className="prescription-container">
          <h2>{prescriptiondata.title}</h2>
          <h3>{prescriptiondata.subheading}</h3>
          <p>{prescriptiondata.para}</p>
         </div>

        <div className="image-container">
          <img src={prescriptiondata.image} alt={prescriptiondata.title} />
        </div>
      </div>
      <CardsContainer
        heading={rightfittitle}
        services={Object.values(rightfitdata)}
        className="rightfit-cardscontainer"
      />

      <div className="pharmacy-queues">
        <h2 className="pharmacy-title">{pharmacyqueuesdata.title}</h2>

        <div className="pharmacy-content">
          <div className="prescription-container">
            <h3>{pharmacyqueuesdata.subheading}</h3>
            <p>{pharmacyqueuesdata.para}</p>
          </div>

          <div className="image-container">
            <img
              src={pharmacyqueuesdata.image}
              alt={pharmacyqueuesdata.title}
            />
          </div>
        </div>
      </div>

      <div className="physio-testimonials-container">
        <Testimonials
          data={medicinehomeData}
          textKey="desc"
          imgKey="userimg"
          nameKey="username"
          className="physio-testimonials"
        />
      </div>

      <ServicesGrid
        title="Check Our Other Services"
        exclude="Medicine Home Delivery"
      />

      <Footer />
    </>
  );
};

export default Medicinehome;
